<template>
  <div v-cloak >

    <el-dialog
      :title="title"
      :visible.sync="showDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="500px"
      size="tiny">
      <div class="dialog">{{msg}}</div>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleConfirm">{{confirmButtonLabel}}</el-button>
              <el-button @click="showDialogVisible = false">{{CancelButtonLabel}}</el-button>
            </span>
    </el-dialog>

  </div>
</template>

<script>


  export default {
    props: {
      title:{
        type: String,
        required: false,
        default: () => 'Confirm Operation'
      },
      msg: {
        type: String,
        required: false,
        default: () => 'Confirm Operation?'
      },
      confirmButtonLabel: {
        type: String,
        required: false,
        default: () => 'Confirm'
      },
      CancelButtonLabel:  {
        type: String,
        required: false,
        default: () => 'Cancel'
      }
    },
    components: {

    },
    data(){
      return{
        showDialogVisible: false
      }
    },
    computed: {

    },
    created(){
    },

    methods: {
      handleConfirm(){
        this.$emit("handleConfirm");
      },
      showDialog(){
        this.showDialogVisible = true;
      },
      hideDialog(){
        this.showDialogVisible = false;
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
  .el-form-item /deep/ .el-select{
    display: inline-block;
    width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/confirmation_box.vue